<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Telefone</th>
        <th scope="col" class="border-0">Contato</th>
        <th scope="col" class="border-0">Cliente desde</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in customers" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-customer-edit', params: { customerId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-3">{{ row.email }}</td>
        <td class="td-2">{{ row.phone }}</td>
        <td class="td-2">{{ (row.contacts.length > 0) ? row.contacts[0].name : row.name }}</td>
        <td class="td-2">{{ row.f_started_at }}</td>
        <td class="td-2">
          <customer-buttons :customer="row"></customer-buttons>
        </td>
      </tr>
      <tr v-if="customers.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum cliente cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de cliente"
      message="Tem certeza que deseja excluir esse cliente?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import CustomerButtons from './CustomerButtons.vue';
import CustomerDelete from './CustomerDelete';
import { _DELETE_CUSTOMER_ } from './CustomerModel';

export default {
  name: 'customer-table',
  mixins: [CustomerDelete],
  components: {
    CustomerButtons,
    ConfirmationModal,
  },
  props: {
    customers: {
      type: Array,
    },
  },
  data() {
    return {
      selectCustomer: null,
    };
  },
  mounted() {
    Events.$on(_DELETE_CUSTOMER_, customer => {
      this.selectCustomer = customer.id;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
